export default __webpack_public_path__ + "static/new_01-32f1d946b860b0ebcdcd9ff2fb2c1dde.webp";